(function () {
function initGl(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var data = JSON.parse(root.querySelector('.gl-data').textContent);
  var M = data.models, PACKS = data.packs;
  var LABELS = ['Frente', 'Lateral', 'Trasera', 'Detalle'];
  var state = { pack: data.defaultPack || 2, slots: [], viewing: null, media: 0, toast: '', warn: '', packChosen: false };
  var $ = function (s) { return root.querySelector(s); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  var money = function (n) { return '$' + (Math.round(n * 100) / 100).toString(); };
  var thumbOf = function (m) { return m.thumb || (m.photos && m.photos[0] && m.photos[0].src) || m.poster || ''; };
  var imgOrPh = function (src, cls, alt) { return src ? '<img class="' + cls + '" src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="lazy">' : '<span class="gl-ph ' + cls + '">Sin foto</span>'; };
  var toastTimer;

  function mediaList(m) {
    var list = [];
    (m.photos || []).forEach(function (p, i) { var src = typeof p === 'string' ? p : p.src; var lab = (typeof p === 'object' && p.label) ? p.label : (LABELS[i] || ('Foto ' + (i + 1))); list.push({ type: 'img', label: lab, src: src }); });
    if (m.video) list.splice(list.length ? 1 : 0, 0, { type: 'video', label: 'Video 360°', src: m.video, poster: m.poster });
    return list;
  }

  function renderPacks() {
    var html = '';
    [1, 2, 3].forEach(function (n) {
      var p = PACKS[n], on = n === state.pack, per = p.price / n;
      var pct = Math.round((1 - p.price / p.list) * 100);
      html += '<button type="button" class="gl-pack" role="radio" aria-checked="' + on + '" data-pack="' + n + '">' +
        '<span class="gl-pack__dot"></span>' +
        '<span class="gl-pack__main"><span class="gl-pack__name">' + p.label + '</span>' +
        '<span class="gl-pack__sub">' + money(Math.round(per * 100) / 100) + ' c/u · ' + (p.ship ? '+ ' + money(p.ship) + ' envío' : 'Envío gratis') + '</span></span>' +
        '<span class="gl-pack__price"><strong>' + money(p.price) + '</strong><span><s>' + money(p.list) + '</s> · Ahorras ' + pct + '%</span></span>' +
        (p.tag ? '<span class="gl-pack__tag">' + esc(p.tag) + '</span>' : '') + '</button>';
    });
    $('.gl-packs').innerHTML = html;
  }

  function renderSel() {
    var P = PACKS[state.pack], count = state.slots.length, done = count === state.pack;
    $('.gl-sel__pack').textContent = 'Pack ' + P.label + ' · ' + money(P.price) + (P.ship ? ' + envío' : ' · envío gratis');
    var c = $('.gl-sel__count'); c.textContent = count + ' de ' + state.pack; c.classList.toggle('is-done', done);
    var bars = '', slots = '';
    for (var k = 0; k < state.pack; k++) {
      var mi = state.slots[k], full = mi !== undefined, next = !full && k === count;
      bars += '<span class="' + (full ? 'is-full' : next ? 'is-next' : '') + '"></span>';
      if (full) {
        var m = M[mi];
        slots += '<div class="gl-slot is-full"><span class="gl-slot__lbl">GORRA ' + (k + 1) + '</span>' + imgOrPh(thumbOf(m), 'gl-slot__img', '') +
          '<span class="gl-slot__name">' + esc(m.name) + '</span><button type="button" class="gl-slot__rm" data-rm="' + k + '" aria-label="Quitar ' + esc(m.name) + ' de Gorra ' + (k + 1) + '">✕ Quitar</button></div>';
      } else {
        slots += '<div class="gl-slot' + (next ? ' is-next' : '') + '"><span class="gl-slot__lbl">GORRA ' + (k + 1) + '</span><span class="gl-slot__empty">' + (next ? '+ Elige aquí' : 'Pendiente') + '</span></div>';
      }
    }
    $('.gl-sel__bars').innerHTML = bars;
    $('.gl-sel__slots').innerHTML = slots;
    var msg = $('.gl-sel__msg');
    var text = state.warn || state.toast || (done ? 'Selección completa. Revisa y toca "Pedir ahora".' : '');
    msg.hidden = !text; msg.textContent = text; msg.classList.toggle('is-warn', !!state.warn);
  }

  function renderGrid() {
    var html = '';
    M.forEach(function (m, i) {
      var pos = [];
      state.slots.forEach(function (x, j) { if (x === i) pos.push(j + 1); });
      html += '<button type="button" class="gl-tile' + (pos.length ? ' is-picked' : '') + '" data-open="' + i + '"' + (m.available ? '' : ' disabled') + ' aria-label="Ver ' + esc(m.name) + '">' +
        imgOrPh(thumbOf(m), 'gl-tile__img', '') + '<span class="gl-tile__name">' + esc(m.name) + '</span>' +
        '<span class="gl-tile__see">' + (m.available ? '▶ Ver 360°' : 'Agotado') + '</span>' +
        (pos.length ? '<span class="gl-tile__badge">Gorra ' + pos.join(' y ') + '</span>' : '') + '</button>';
    });
    $('.gl-grid').innerHTML = html;
  }

  function renderBar() {
    var P = PACKS[state.pack], count = state.slots.length, done = count === state.pack, rem = state.pack - count;
    $('.gl-bar__label').textContent = P.label + (P.ship ? ' + envío' : ' · envío gratis');
    $('.gl-bar__total').textContent = money(P.price + P.ship);
    var b = $('.gl-bar__cta'); b.disabled = !done;
    b.textContent = done ? 'Pedir ahora · ' + money(P.price + P.ship) : 'Elige ' + rem + ' gorra' + (rem > 1 ? 's' : '') + ' más';
    root.querySelectorAll('.gl-step').forEach(function (s) {
      var n = +s.dataset.step, cur = done ? 3 : (state.packChosen || count > 0 ? 2 : 1);
      s.classList.toggle('is-on', n === cur); s.classList.toggle('is-done', n < cur);
    });
  }

  function renderSheet() {
    var sh = $('.gl-sheet');
    if (state.viewing === null) { sh.hidden = true; return; }
    var m = M[state.viewing], list = mediaList(m), cur = list[state.media] || null, count = state.slots.length;
    $('.gl-sheet__pos').textContent = list.length ? (cur && cur.type === 'video' ? 'Video 360°' : 'Foto') + ' · ' + (state.media + 1) + ' de ' + list.length : '';
    $('.gl-sheet__nav--prev').hidden = $('.gl-sheet__nav--next').hidden = list.length < 2;
    var stage = $('.gl-sheet__stage');
    if (!cur) stage.innerHTML = '<span class="gl-ph">Multimedia pendiente</span>';
    else if (cur.type === 'video') stage.innerHTML = '<video src="' + esc(cur.src) + '"' + (cur.poster ? ' poster="' + esc(cur.poster) + '"' : '') + ' autoplay muted loop playsinline preload="metadata"></video>';
    else stage.innerHTML = '<img src="' + esc(cur.src) + '" alt="' + esc(m.name + ' · ' + cur.label) + '">';
    var tag = $('.gl-sheet__tag'); tag.textContent = cur ? cur.label.toUpperCase() : ''; tag.hidden = !cur;
    var tabs = '';
    list.forEach(function (it, j) {
      tabs += '<button type="button" class="gl-tab" role="tab" aria-selected="' + (j === state.media) + '" data-media="' + j + '" aria-label="' + esc(it.label) + '">' +
        (it.type === 'img' ? '<img src="' + esc(it.src) + '" alt="">' : (it.poster ? '<img src="' + esc(it.poster) + '" alt="">' : '▶ 360°')) + '</button>';
    });
    var tb = $('.gl-sheet__tabs'); tb.innerHTML = tabs; tb.hidden = list.length < 2;
    $('.gl-sheet__name').textContent = m.name;
    $('.gl-sheet__target').textContent = count < state.pack ? 'Irá como Gorra ' + (count + 1) : 'Selección completa';
    $('.gl-sheet__desc').textContent = m.desc || '';
    var ch = $('.gl-sheet__choose');
    ch.disabled = count >= state.pack;
    ch.textContent = count < state.pack ? 'Elegir esta gorra (' + (count + 1) + ' de ' + state.pack + ')' : 'Ya elegiste tus ' + state.pack;
    if (sh.hidden) { sh.hidden = false; document.documentElement.style.overflow = 'hidden'; $('.gl-sheet__close').focus(); }
  }

  function renderAll() { renderPacks(); renderSel(); renderGrid(); renderBar(); renderSheet(); }

  function stepMedia(d) {
    if (state.viewing === null) return;
    var n = mediaList(M[state.viewing]).length; if (n < 2) return;
    state.media = (state.media + d + n) % n; renderSheet();
    var on = $('.gl-sheet__tabs [aria-selected="true"]'); if (on && on.scrollIntoView) on.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  (function () {
    var st = $('.gl-sheet__media'), x0 = null, y0 = 0;
    if (!st) return;
    st.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    st.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) stepMedia(dx < 0 ? 1 : -1);
    }, { passive: true });
  })();

  function closeSheet() { state.viewing = null; $('.gl-sheet').hidden = true; document.documentElement.style.overflow = ''; }

  function setToast(t) {
    state.toast = t; state.warn = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { state.toast = ''; renderSel(); }, 2500);
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
    if (t.dataset.pack) {
      var n = +t.dataset.pack, dropped = state.slots.slice(n);
      state.pack = n; state.packChosen = true; state.slots = state.slots.slice(0, n); state.toast = '';
      state.warn = dropped.length ? 'Cambiaste a ' + PACKS[n].label + ': quitamos ' + dropped.map(function (i) { return M[i].name; }).join(', ') + '.' : '';
      renderAll(); return;
    }
    if (t.dataset.open !== undefined) { state.viewing = +t.dataset.open; state.media = 0; renderSheet(); return; }
    if (t.dataset.rm !== undefined) { state.slots.splice(+t.dataset.rm, 1); state.toast = ''; state.warn = ''; renderAll(); return; }
    if (t.dataset.media !== undefined) { state.media = +t.dataset.media; renderSheet(); return; }
    if (t.classList.contains('gl-sheet__nav--prev') || t.classList.contains('gl-sheet__nav--next')) {
      stepMedia(t.classList.contains('gl-sheet__nav--prev') ? -1 : 1); return;
    }
    if (t.classList.contains('gl-sheet__choose')) {
      if (state.slots.length >= state.pack) return;
      state.slots.push(state.viewing); state.packChosen = true;
      setToast(M[state.viewing].name + ' agregada como Gorra ' + state.slots.length);
      closeSheet(); renderAll(); return;
    }
    if (t.classList.contains('gl-confirm__scrim') || t.classList.contains('gl-confirm__close')) { $('.gl-confirm').hidden = true; document.documentElement.style.overflow = ''; return; }
    if (t.classList.contains('gl-sheet__scrim') || t.classList.contains('gl-sheet__close')) { closeSheet(); return; }
    if (t.classList.contains('gl-bar__cta')) { if (state.slots.length === state.pack) checkout(t); return; }
    if (t.classList.contains('gl-confirm__go')) { checkout(t); return; }
    if (t.classList.contains('gl-hero__nav--prev') || t.classList.contains('gl-hero__nav--next')) {
      var tr = $('.gl-hero__track'), w = tr.clientWidth;
      tr.scrollBy({ left: t.classList.contains('gl-hero__nav--prev') ? -w : w, behavior: 'smooth' });
    }
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !$('.gl-sheet').hidden) { stepMedia(e.key === 'ArrowLeft' ? -1 : 1); return; }
    if (e.key !== 'Escape') return;
    if (!$('.gl-sheet').hidden) closeSheet();
    if (!$('.gl-confirm').hidden) { $('.gl-confirm').hidden = true; document.documentElement.style.overflow = ''; }
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) renderBar(); });

  function checkout(btn) {
    btn.disabled = true; btn.textContent = 'Abriendo formulario…';
    var counts = {};
    state.slots.forEach(function (i) { counts[M[i].id] = (counts[M[i].id] || 0) + 1; });
    var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
    fetch(root.dataset.cartClear + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } })
      .then(function () {
        return fetch(root.dataset.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = root.dataset.cartUrl + '?cod=1'; })
      .catch(function () {
        state.warn = 'No pudimos preparar tu pedido. Intenta de nuevo.'; renderSel();
        btn.disabled = false; btn.textContent = 'Reintentar';
      });
  }

  var track = $('.gl-hero__track'), dots = $('.gl-hero__dots'), nSlides = track.children.length;
  dots.innerHTML = new Array(nSlides + 1).join('<span></span>');
  function syncDots() {
    var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    dots.querySelectorAll('span').forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
  }
  track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
  if (nSlides < 2) root.querySelectorAll('.gl-hero__nav').forEach(function (b) { b.hidden = true; });
  syncDots();

  renderAll();
}
document.querySelectorAll('.gl[data-gl]').forEach(initGl);
document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.gl[data-gl]').forEach(initGl); });
})();
